import { FUNCTION_URLS } from "../config/functionUrls";

const VEXA_COMPILE_URL = FUNCTION_URLS.vexaCompile;
const VEXA_RECOMPILE_URL = FUNCTION_URLS.vexaRecompile;
const VEXA_STATUS_URL = FUNCTION_URLS.vexaStatus;
const VEXA_DELETE_URL = FUNCTION_URLS.vexaDeleteManual;
const VEXA_HEALTH_URL = FUNCTION_URLS.vexaHealth;

async function post(url, body) {
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const err = await response.text();
    throw new Error(`Vexa API error ${response.status}: ${err}`);
  }
  return response.json();
}

async function get(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const err = await response.text();
    throw new Error(`Vexa API error ${response.status}: ${err}`);
  }
  return response.json();
}

async function del(url) {
  const response = await fetch(url, { method: "DELETE" });
  if (!response.ok) {
    const err = await response.text();
    throw new Error(`Vexa API error ${response.status}: ${err}`);
  }
  return response.json();
}

export const vexaCompilationService = {
  async compileManual(manualId, version = "1.0.0", { content, module, screen, title } = {}) {
    return post(VEXA_COMPILE_URL, { manualId, version, content, module, screen, title });
  },

  async recompileManual(manualId, version = "1.0.0") {
    return post(VEXA_RECOMPILE_URL, { manualId, version });
  },

  async getStatus(manualId) {
    return get(`${VEXA_STATUS_URL}?manualId=${encodeURIComponent(manualId)}`);
  },

  async deleteManual(manualId) {
    return del(`${VEXA_DELETE_URL}?manualId=${encodeURIComponent(manualId)}`);
  },

  async health() {
    return get(VEXA_HEALTH_URL);
  },

  async pollStatus(manualId, onUpdate, intervalMs = 3000) {
    return new Promise((resolve, reject) => {
      const poll = async () => {
        try {
          const status = await this.getStatus(manualId);
          onUpdate(status);

          if (status.status === "READY" || status.status === "FAILED" || status.status === "SKIPPED") {
            resolve(status);
            return;
          }

          setTimeout(poll, intervalMs);
        } catch (error) {
          reject(error);
        }
      };
      poll();
    });
  },
};

export default vexaCompilationService;
